import { FabricText, Group } from 'fabric';
import { MapGrouping } from './map-grouping';
import { MapGroupEntry } from './map-group-entry';
import { PoseObject } from '@ng-cloud/badger-core/map/objects/pose-object';
import { Pose } from '@ng-cloud/badger-core/models/pose';
import { Layers } from './map-layer';

@Layers([
  { name: 'poses', zIndex: 30 }
])
export class PoseObjectGrouping extends MapGrouping<Pose, PoseObject> {
  constructor(options: any = {}) {
    super(options);
  }

  createObject(data: Pose): PoseObject {
    const poseObj = new PoseObject(this.storeMap.poseToPixels(data), this.options);
    const startYaw = poseObj.pose.yaw;
    poseObj.robotOptions = this.options.robotOptions || {};
    poseObj.robotOrientationOptions = this.options.robotOrientationOptions || {};
    (poseObj.getFabric() as Group).add(this.createLabel(poseObj.pose));
    poseObj.poseChanged.subscribe((pose: Pose) => {
      const entryForPose = this.entries.find(entry => entry.object == poseObj);
      entryForPose.data = this.storeMap.poseToMeters(pose);
    });

    return poseObj;
  }

  protected getIndexOfData(pose: Pose): number {
    return this.entries.findIndex(dataEntry => this.getIdentifier(dataEntry.object.pose) === this.getIdentifier(pose));
  }

  protected createLabel(pose: Pose) {
    const poseLabel = new FabricText(pose.name || '', {
      fontSize: 14,
      fontFamily: 'Roboto, "Helvetica Neue", sans-serif',
      originX: 'center',
      top: pose.y + 7,
      left: pose.x
    });
    return poseLabel;
  }

  decorate() {
    this.entries.filter(entry => ['loading', 'verification'].includes(entry.data.settings['area_type'])).forEach(location => {
      location.data.settings['area_type'] === 'loading' ? location.object.setFirst() : location.object.setCautionCone();
    });
  }

  setData(poses: Pose[]): MapGroupEntry<Pose, PoseObject>[] {
    const entries = super.setData(poses);
    this.decorate();
    return entries;
  }
}
